import styled from '@emotion/styled';
import { TextareaAutosize } from '@mui/material';
import { IJDGeneratorDTO } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { failed, success } from '../../../../utils/NotificationMessages';

export const industryCategories = [
  { label: 'Accountancy', value: 'Accountancy' },
  { label: 'Administration', value: 'Administration' },
  { label: 'Advertising', value: 'Advertising' },
  { label: 'Aerospace/Aviation/Defence', value: 'Aerospace/Aviation/Defence' },
  { label: 'Agriculture', value: 'Agriculture' },
  { label: 'Architecture', value: 'Architecture' },
  { label: 'Art/Design/Graphics', value: 'Art/Design/Graphics' },
  { label: 'Automotive', value: 'Automotives' },
  { label: 'Banking', value: 'Banking' },
  { label: 'Biotechnology', value: 'Biotechnology' },
  {
    label: 'Catering &amp; Food Services',
    value: 'Catering &amp; Food Services',
  },
  {
    label: 'Charity/Voluntary/Non Profit',
    value: 'Charity/Voluntary/Non Profit',
  },
  { label: 'Construction', value: 'Construction' },
  { label: 'Consultancy', value: 'Consultancy' },
  { label: 'Counseling', value: 'Counseling' },
  { label: 'Customer service', value: 'Customer service' },
  { label: 'Dental', value: 'Dental' },
  { label: 'Driving', value: 'Driving' },
  { label: 'Education', value: 'Education' },
  { label: 'Electrical', value: 'Electrical' },
  { label: 'Electronic', value: 'Electronic' },
  { label: 'Emergency', value: 'Emergency' },
  { label: 'Engineering', value: 'Engineering' },
  { label: 'Entertainment', value: 'Entertainment' },
  { label: 'Fashion', value: 'Fashion' },
  { label: 'Financial', value: 'Financial' },
  { label: 'Graduate', value: 'Graduate' },
  { label: 'Health &amp; Safety', value: 'Health &amp; Safety' },
  { label: 'Health medical', value: 'Health medical' },
  { label: 'Home worker', value: 'Home worker' },
  { label: 'Hotel/Hospitality', value: 'Hotel/Hospitality' },
  {
    label: 'Human-resources &amp; Employment',
    value: 'Human-resources &amp; Employment',
  },
  { label: 'IT/Internet/Technical', value: 'IT/Internet/Technical' },
  { label: 'Import export', value: 'Import export' },
  { label: 'Industrial', value: 'Industrial' },
  { label: 'Insurance', value: 'Insurance' },
  { label: 'Journalism', value: 'Journalism' },
  { label: 'Legal', value: 'Legal' },
  { label: 'Leisure', value: 'Leisure' },
  { label: 'Management &amp; Executive', value: 'Management &amp; Executive' },
  { label: 'Manufacturing', value: 'Manufacturing' },
  { label: 'Marketing &amp; PR', value: 'Marketing &amp; PR' },
  { label: 'Mechanical', value: 'Mechanical' },
  { label: 'Media/Creative/Digital', value: 'Media/Creative/Digital' },
  { label: 'Nursing', value: 'Nursing' },
  { label: 'Oil &amp; Gas/Energy', value: 'Oil &amp; Gas/Energy' },
  { label: 'Other', value: 'Other' },
  { label: 'Packaging', value: 'Packaging' },
  { label: 'Pharmaceutical', value: 'Pharmaceutical' },
  { label: 'Photography', value: 'Photography' },
  { label: 'Printing', value: 'Printing' },
  { label: 'Property', value: 'Property' },
  { label: 'Public sector', value: 'Public sector' },
  { label: 'Publishing', value: 'Publishing' },
  { label: 'Purchasing/Procurement', value: 'Purchasing/Procurement' },
  { label: 'Recruitment', value: 'Recruitment' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Scientific', value: 'Scientific' },
  { label: 'Secretarial &amp; PA', value: 'Secretarial &amp; PA' },
  { label: 'Security', value: 'Security' },
  { label: 'Social services', value: 'Social services' },
  { label: 'Teaching', value: 'Teaching' },
  { label: 'Telecomms', value: 'Telecomms' },
  { label: 'Textiles', value: 'Textiles' },
  {
    label: 'Trades - Skilled &amp; Unskilled',
    value: 'Trades - Skilled &amp; Unskilled',
  },
  { label: 'Transport &amp; Logistics', value: 'Transport &amp; Logistics' },
  { label: 'Travel &amp; Tourism', value: 'Travel &amp; Tourism' },
  {
    label: 'Utilities &amp; Installation',
    value: 'Utilities &amp; Installation',
  },
  { label: 'Warehouse', value: 'Warehouse' },
  { label: 'Waste management', value: 'Waste management' },
];

export const jobTypeList = [
  'Permanent',
  'Contract',
  'Freelance',
  'Internship',
  'Temporary',
  'ContractToHireIndependent',
  'PermanentAndContract',
  'None',
];

export const aboutUsPlaceHolder = `IBM is a global technology company with a presence in 100+ countries and a revenue of 61B dollars.\nAdd your own company description in less than 100 characters.`;

export const jdGenerator: IJDGeneratorDTO = {
  jobtitle: '',
  location: [],
  skills: [],
  yoe: 0,
  industry: '',
  about_company: '',
};

export const jdGeneratedSuccess = () => success('Successfully generated job description !!');

export const jdGeneratedFailed = () => failed('Failed to generate job, Please try again !! ');

export const jdGeneratedError = () =>
  failed('Error while generating job description, Please try again !! ');

export const StyledTextareaAutosize = styled(TextareaAutosize)(() => ({
  minWidth: '1040px',
  backgroundColor: WsColors.White,
  border: 'none',
  outline: '2px solid' + WsColors.TertiaryShades200,
  borderRadius: '5px',
  fontFamily: 'sans-serif',
}));
